var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticStyle:{"margin-top":"10px"},attrs:{"fixed":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v("2021 | TCE-MA - Todos os Direitos Reservados ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }